import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import CustomDialog from "../common/tableComponent.js/dialog";
import { makeRequest } from "../common/customServiceCall/serviceCall";
import { useSelector } from "react-redux";
import { Calendar } from "primereact/calendar";
import { InputText } from "primereact/inputtext";
import { ProgressSpinner } from "primereact/progressspinner";
import { Toast } from "primereact/toast";
import { format } from "date-fns";
import ReactTooltip from "react-tooltip";

const JunkName = () => {
  const userDetails = useSelector((state) => state.login.userDetails);
  const toast = useRef(null);

  const [loading, setLoading] = useState(false);
  const [junknames, setJunknames] = useState([]);
  const [showAddModal, setShowAddModal] = useState(false);
  const [dateRange, setDateRange] = useState(null);
  const [content, setContent] = useState("");

  const [formData, setFormData] = useState({
    content: "",
  });

  const actions = (rowData) => (
    <>
      <Button
        label=""
        icon="pi pi-eye"
        className="p-button-success p-mr-2"
        // onClick={() => handleViewModalDisplay(rowData)}
        style={{ fontSize: "15px", padding: "7px" }}
        data-tip="View Details"
        data-for="toolTip1"
        data-place="top"
      />

      <ReactTooltip id="toolTip1" />
    </>
  );

  const fetchData = async () => {
    setLoading(true); // Start loading

    const requestData = {
      sd: dateRange && dateRange[0] ? format(dateRange[0], "yyyy-MM-dd") : "", // Check if dateRange and startDate are valid
      ed: dateRange && dateRange[1] ? format(dateRange[1], "yyyy-MM-dd") : "",
      content: content || "",
      size: "9999999",
      page: "1",
    };
    const filteredRequestData = Object.fromEntries(
      Object.entries(requestData).filter(([key, value]) => value !== "")
    );

    const queryString = new URLSearchParams(filteredRequestData).toString();
    try {
      const response = await makeRequest(
        "get",
        `/junkname/api/v1/junknames/?${queryString}`
      );
      if (response.code === "00") {
        const fetchedData = response.data;
        console.log(fetchedData);
      } else {
        console.error("Failed to fetch data:", response.message);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false); // Stop loading
    }
  };

  useEffect(() => {
    fetchData();
  }, [content, dateRange]); // Re-fetch data when filters change

  const getSearchedData = () => {
    fetchData(); // Re-fetch the data with the updated filters
  };

  const dateTemplate = (rowData) => {
    return <p>{format(new Date(rowData.createdAt), "yyyy-MM-dd HH:mm:ss")}</p>;
  };

  const cardStyle = { borderRadius: "40px" };

  const labelStyleLeft = { fontSize: "14px" };

  const labelStyleRight = {
    fontSize: "14px",
    float: "left",
    fontWeight: "500",
  };

  return (
    <section className="p-my-4 p-md-12 p-xl-12" style={{ padding: "0px 10%" }}>
      <Toast ref={toast} />

      <div className="p-grid p-fluid">
        <div
          className="p-col-12 p-sm-12 p-md-10 p-lg-10 p-xl-10 p-md-offset-1 p-lg-offset-1 p-xl-offset-1"
          style={{ textAlign: "center" }}
        >
          <span className="p-tag custom-heading">Junk Names</span>
        </div>
      </div>

      <div className="card" style={{ paddingTop: "0px" }}>
        <div
          className="p-grid p-align-center p-fluid"
          style={{ paddingTop: "30px" }}
        >
          {/* Date Range Picker */}
          <div className="p-field p-col-12 p-md-3">
            <span className="p-float-label">
              <Calendar
                value={dateRange}
                onChange={(e) => setDateRange(e.value)} // Set date range
                selectionMode="range"
                readOnlyInput
                showIcon
                placeholder="Select Date Range"
              />
            </span>
          </div>

          <div className="p-field p-col-12 p-md-3">
            <div className="p-inputgroup">
              <InputText
                value={content}
                onChange={(e) => setContent(e.target.value)}
                placeholder="Enter content"
              />

              <Button
                onClick={getSearchedData}
                icon="pi pi-search"
                className="p-button-info"
              />
            </div>
          </div>
          <div className="p-field p-col-12 p-md-3">
            <Button
              icon="pi pi-plus"
              // onClick={handleAddModalDisplay}
              className="p-button-info"
              style={{ fontSize: "15px", marginLeft: "10px" }}
              data-tip="Add User"
              data-for="toolTip1"
              data-place="top"
            />
          </div>
        </div>
      </div>
      <div className="card">
        {loading ? (
          <div style={{ textAlign: "center", padding: "20px" }}>
            <ProgressSpinner
              style={{
                display: userDetails.showLoader,
                width: "40px",
                height: "40px",
                position: "fixed",
                top: "50%",
                left: "50%",
                bottom: "50%",
                right: "50%",
                zIndex: "1111111111",
              }}
              strokeWidth="3"
              animationDuration=".5s"
            />
          </div>
        ) : (
          <DataTable
            value={junknames}
            paginator
            rows={5}
            rowsPerPageOptions={[5, 10, 25, 50]}
            tableStyle={{ minWidth: "60rem" }}
            className="p-datatable-responsive-demo"
          >
            <Column
              field="content"
              header="Content"
              style={{ width: "25%" }}
            ></Column>

            <Column
              field="createdAt"
              header="Created At"
              style={{ width: "25%" }}
              body={dateTemplate}
            ></Column>
            <Column
              header="Actions"
              style={{ width: "25%" }}
              body={actions}
            ></Column>
          </DataTable>
        )}
      </div>
      <>
       <CustomDialog
          visible={showAddModal}
          header="Junk Name"
          onClose={() => setShowAddModal(false)}
        >
          <div
            className="p-grid p-fluid"
            style={{ height: "70vh", overflowY: "scroll" }}
          >
            <div className="p-col-12">
              <div className="p-field">
                <label htmlFor="content">Send Box API URL</label>
                <InputText
                  id="content"
                  value={formData.content}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      content: e.target.value,
                    })
                  }
                  placeholder="Enter Send Box API URL"
                />
              </div>
            </div>
            </div>
            </CustomDialog>
      </>
    </section>
  );
};

export default JunkName;
